/**
 * 字段有效值过滤器
 * null, undefined, '', 返回'--', 其他返回原值
 */
export default function fieldVaild(val) {
    const invalidMap = [
        null,
        undefined,
        '',
    ];

    return invalidMap.some(v => v === val) ? '--' : val;
}
